var storage = function() 
{
    function getCookie(name) {
        // Add the = sign 
        name = name + '=';
    
        // Get the decoded cookie
        var decodedCookie = decodeURIComponent(document.cookie);
    
        // Get all cookies, split on ; sign
        var cookies = decodedCookie.split(';');
    
        // Loop over the cookies
        for (var i = 0; i < cookies.length; i++) {
            // Define the single cookie, and remove whitespace
            var cookie = cookies[i].trim();
        
            // If this cookie has the name of what we are searching
            if (cookie.indexOf(name) == 0) {
                // Return everything after the cookies name
                return cookie.substring(name.length, cookie.length);
            }
        }
    }

    function getData(key) {
        var data = localStorage.getItem(key);

        // if no data is found, see if an old cookie exists
        if (!data) {
            var cookie = getCookie(key);

            if (cookie) {
                data = cookie;
                localStorage.setItem(key, data);

                // delete old cookie
                document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }
        }

        return data;
    }

    function getSavedGameData() {
        var gamedata = getData("gameV2");
        
        if (gamedata === null)
        {
            // todo: remove this code after a few months
            gamedata = getCookie("game");

            if (gamedata !== undefined && gamedata !== null)
            {                
                var json = "{\"games\":[" + gamedata + "]}";
                
                localStorage.setItem("gameV2", json);

                // delete old cookie
                document.cookie = "game=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";

                gamedata = getData("gameV2");
            }
        }

        return gamedata;
    }

    function saveGameData(games) {
        var json = "{\"games\":" + JSON.stringify(games) + "}";

        localStorage.setItem("gameV2", json);
    }

    function saveSettings(darkModeOn, desktopMouse)
    {
        var json = "{\"darkmode\": " + darkModeOn + ",\"desktopmouse\": " + desktopMouse + "}";

        localStorage.setItem("settings", json);
    }

    function saveStats(statCompletedGames,
        statMaxStreak,
        statCurrentStreak,
        statAveragePercentage,
        statGamesCompleted
    )
    {
        var json = "{\"completedGames\": ";

        json += JSON.stringify(statCompletedGames);

        json += ",";      
        json += "\"maxStreak\": " + statMaxStreak + ",";
        json += "\"currentStreak\": " + statCurrentStreak + ",";
        json += "\"averagePercentage\": " + statAveragePercentage + ",";
        json += "\"gamesCompleted\": " + statGamesCompleted;

        json += "}";      

        localStorage.setItem("statsV2", json);
    }

    function getStats()
    {
        return getData("statsV2");
    }

    function getSettings()
    {
        return getData("settings");
    }
    
    return {
        getSavedGameData: getSavedGameData,
        getStats: getStats,
        getSettings: getSettings,
        saveGameData: saveGameData,
        saveSettings: saveSettings,
        saveStats: saveStats
    };
}();

export { storage }